import WithCurrentDealer from "../WithCurrentDealer/index";
import JustForStaff from "../JustForStaff/index";
import { compose, setDisplayName } from "recompose";
import WithUserRole from "../WithUserRole";

export default compose(
  setDisplayName("CustomersLayout"),
  WithUserRole,
  WithCurrentDealer,
  JustForStaff
);
